import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ICruiseDetail } from '../../interfaces/icruise-detail';
import { CruiseStepMarkersPipe } from '../../pipes/cruise-step-markers.pipe';

@Component({
  selector: 'app-cruise-detail-content-itinerary',
  templateUrl: './cruise-detail-content-itinerary.component.html',
  styleUrls: ['./cruise-detail-content-itinerary.component.scss'],
})
export class CruiseDetailContentItineraryComponent implements OnChanges {
  @Input() cruise$: Observable<ICruiseDetail>;
  @Input() reloadPosition: boolean = false;
  @ViewChild('googleMapRef') googleMapRef;

  public isCollapsed = true;

  cruiseSubscription: Subscription;
  bounds: google.maps.LatLngBounds;
  markersSteps: any;
  polylineSteps: any;

  config = {
    breakpoints: {
      320: {
        direction: 'horizontal',
        slidesPerView: 1,
      },
      992: {
        direction: 'vertical',
        slidesPerView: 5,
        centeredSlides: false,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  index;

  expandDesc;
  expandDesc2;

  constructor(private _cruiseStepMarkersPipe: CruiseStepMarkersPipe) {}

  ngOnChanges(changes: SimpleChanges) {
    if(changes.reloadPosition && !changes.reloadPosition.isFirstChange() && changes.reloadPosition.currentValue !== changes.reloadPosition.previousValue){
      this.setBounds();
    }
  }

  setBounds() {
    if (!this.cruiseSubscription) {
      // FIXME: trovare un migliore punto per settare i bounds anziche' utilizzare la callback 'tiltChanged' di gmaps (vedi la view)
      this.cruiseSubscription = this.cruise$.subscribe((e) => {
        if (!e?.steps) return;
        
        this.markersSteps = [...this._cruiseStepMarkersPipe.transform(e.steps)];
        this.markersSteps.forEach((mk, i, arr) => {
          const next = arr[i + 1] || null;
          //  Se il porto di un determinato giorno è uguale a quello del giorno successivo (la nave è ferma)
          if (next && mk.lat === next.lat && mk.lng === next.lng) {
            next.label = mk.label + '/' + next.label;
            mk.lat = 0;
            mk.lng = 0;
          }
        });
        //  Rimuove tappe duplicate (è sufficiente quanto fatto sopra, ossia indicare lo stazionamento nella label)
        this.markersSteps = this.markersSteps.filter((mk) => mk.lat && mk.lng);
        //  Percorso ad anello: anziché stampare un marker per la prima tappa ed uno per l'ultima (sono uguali) se ne mostra uno adeguandone la label
        const firstStep = this.markersSteps[0];
        const lastStep = this.markersSteps[this.markersSteps.length - 1];
        if (
          firstStep &&
          firstStep.lat === lastStep.lat &&
          firstStep.lng === lastStep.lng
        ) {
          firstStep.label += '/' + lastStep.label;
          this.markersSteps.pop();
        }
        //  Se la label è composta da più di un carattere ne ricuce le dimensioni ed in ogni caso ne limita la lunghezza a massimo 3 caratteri (aggiungendo eventualmente un '+')
        this.markersSteps.forEach((mk) => {
          if (mk.label.length > 3) mk.label = mk.label.substring(0, 3) + '+';
          if (mk.label.length > 1) {
            const label = mk.label;
            mk.label = { text: label, fontSize: '8' };
          }
        });
        //  Linea che definisce il percorso sulla mappa collegando i vari markers
        // this.polylineSteps = [
        //   ...this._cruiseStepMarkersPipe.transform(e.steps),
        // ];
        this.bounds = new google.maps.LatLngBounds();
        if (e) {
          // filtro da eventuali coordinate non valide
          const stepMarkeredFixed = this._cruiseStepMarkersPipe.transform(e.steps).filter(
            marker => marker.lat !== null && !isNaN(marker.lat) && marker.lng !== null && !isNaN(marker.lng)
          );
          stepMarkeredFixed.forEach((x) => {
            if (x) this.bounds.extend(x);
          });
          this.googleMapRef.fitBounds(this.bounds);
        }
      });
    }
  }
}
